export const TAB_ROUTE_PREFIX = {
  HOME: "/(tabs)/(home)",
  STRATEGIES: "/(tabs)/strategies",
  QUOTES: "/(tabs)/quotes",
  ANALYSIS: "/(tabs)/analysis",
  PORTFOLIOS: "/(tabs)/portfolios",
  NOTIFICATIONS: "/(tabs)/(home)/notification-list",
  MENU: "/(tabs)/(home)/menu"
};
